// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IFrameResizer_iframe__SWrGs"};